import PublicLayout from '../components/layouts/PublicLayout';
import { Container, Row, Col } from 'reactstrap';
import { useState, useEffect } from 'react';
import Link from 'next/link';
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router'

function ReviewGuidelines({meta}) {
    const [loading, setLoading] = useState(false); 
  	const router = useRouter();

	return (
        <>
       		 <Head>
	            <meta name="keywords" content={meta ? meta.keywords : ''} />
	            <title>{meta ? meta.title : ''}</title>
	            <meta name="description" content={meta ? meta.description : ''} />
	            <link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
	        </Head>
		<div className="banner_breadcrumb_section" id="about">
				<div id="spinner" className="spinner_req_review" style={{"display": loading ? "block" : "none"}}>
						<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
					</div>
				  <Container fluid="xl">
					<h1 className="main-heading-lg">Review Guidelines</h1>
					</Container>
				  </div>
				  <div className="review-guidelines-page text-center" >
				  	<Container fluid="xl">
					  <div className=" padding-wrap" >
					  <p className="description-text">Toprow is helping professionals build their brands. We are pushing organizational growth for businesses by helping them get their most tedious tasks completed. With an expert on their projects, they can focus on building their business.</p>
					  <p className="description-text">Whether you are a business looking for help with your tasks or a vendor or agency with high level skillset looking for leads, Toprow is the place for you. Our talent matching platform will ensure that you get the best expert for your project and that you close more business.</p>
					  <p className="description-text">If you&#39;re thinking about how to use the platform, here&#39;s how it works.</p>
					  </div>
					</Container>
					  <div className="text-center signup-section-blue padding-wrap">
						<Container fluid="xl">
							<Row>						
								<Col md="6">
								<Link href="/agency/signup"><a className="primary-btn"><span>Sign up for an account</span></a></Link>
								<p className="description-text">Create your profile</p>
								<p className="description-text">Choose whether you are a professional or a business.</p>
								<p className="description-text">Follow the navigation prompts to complete your profile.</p>
								<p className="description-text">If you need help with the process, you can watch this video on how to use Toprow</p>
								<p className="description-text">For professionals, see our <Link href="/toprow-faq"><a>FAQs</a></Link>.</p>
								<p className="description-text">You can also see our  <Link href="/term-of-use"><a>Terms of Use</a></Link> & <Link href="/terms-for-professional"><a>Terms for Professionals</a></Link>.</p>					 
								</Col>
								<Col md="6">
								<video controls src={require("/public/public/Toprowfinal2.mp4")} width="100%" height="auto" />
								</Col>
							</Row>		
						</Container>
					  </div>
				  </div>

				  <div className="home-quote-started_section review-quote-section">
						<Container fluid="xl">
							<div className="padding-wrap text-center">    
							<h4 className="main-heading-lg">Toprow is home to top talent in any industry.</h4>
								<Link href="/categories"><a className="primary-btn"><span>Get Started Now</span></a></Link>
							</div>
						</Container>
			</div>
            </>
	)
}


// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/review-guidelines', { headers: {
            "Accept": "application/json" }
        });

        return { props: { meta: response.data.data,  } }

    } catch (err) {
        const meta = false;

        return { props: { meta } };
    }
}

ReviewGuidelines.Layout = PublicLayout;

export default ReviewGuidelines
